import { ErrorTrack } from '../../error.track';
import { RootScopeEvents } from '../../../../../common/services/root-scope-types';
var SessionStartErrorSubtype;
(function (SessionStartErrorSubtype) {
    SessionStartErrorSubtype["createChannel"] = "create channel failed";
    SessionStartErrorSubtype["createSession"] = "create session failed";
})(SessionStartErrorSubtype || (SessionStartErrorSubtype = {}));
class SessionStartErrorTrack extends ErrorTrack {
    start() {
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.CREATE_CHANNEL_ERROR, (_, { error }) => {
            this.trackStartSessionError(SessionStartErrorSubtype.createChannel, error);
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.CREATE_SESSION_ERROR, (_, { error }) => {
            this.trackStartSessionError(SessionStartErrorSubtype.createSession, error);
        });
    }
    trackStartSessionError(errorSubtype, error = {}) {
        let errorCode = error.status || error.code;
        let errorMessage = error.statusText || error.message;
        if (error.data && error.data.error) {
            errorCode = error.data.error.status;
            errorMessage = error.data.error.message;
        }
        this.trackSegment({
            errorType: 'start session error',
            errorSubtype,
            errorCode,
            errorMessage,
        });
    }
}
export default SessionStartErrorTrack;
